export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Anotace'

export const ANNOTATIONS_TABLE_CHANGE = 'ANNOTATIONS_TABLE_CHANGE'
export const ANNOTATIONS_TABLE_CHANGE_REQUEST = (id) => `ANNOTATIONS_TABLE_${id}_CHANGE_REQUEST`
export const ANNOTATIONS_TABLE_LOADING_TRUE = 'ANNOTATIONS_TABLE_LOADING_TRUE'
export const ANNOTATIONS_TABLE_DATA_RECEIVED = 'ANNOTATIONS_TABLE_DATA_RECEIVED'
export const ANNOTATIONS_TABLE_LOADING_FALSE = 'ANNOTATIONS_TABLE_LOADING_FALSE'
